import React, { Component } from 'react'
import './PrivacyPolicy.css'

class PrivacyPolicy extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div>
        <nav className="navbar navbar-expand-lg navbar-dark navbar-custom fixed-top">
          <div className="container">
            <a className="navbar-brand" href="/">Tree Tracker App</a>
          </div>
        </nav>

        <div className="col-md-5 margin-top-container">
          <h1 id="privacy-policy">Privacy Policy</h1>
          <p>This policy applies to all information collected or submitted on Tree Tracker App&#39;s website and our apps for iPhone and any other devices and platforms.</p>
          <h3 id="information-we-collect">Information we collect</h3>
          <p>When creating an account, you will be asked to enter an email address and a password. Email addresses are <strong>only</strong> used for logging in, password resets, responding to emails that you initiate, and notifications that you request.</p>
          <p>We collect information on trees you log, including but not limited to; condition, size, and location. </p>
          <h3 id="information-usage">Information Usage</h3>
          <p>Information on trees may be anonymously shared with organizations or groups that you choose. We also collect anonymous statistics for views on various pages in the application.</p>
          <h3 id="california-online-privacy-protection-act-compliance">California Online Privacy Protection Act Compliance</h3>
          <p>We comply with the California Online Privacy Protection Act. We therefore will not distribute your personal information to outside parties without your consent.</p>
          <h3 id="your-consent">Your Consent</h3>
          <p>By using our site or apps, you consent to our privacy policy.</p>
        </div>
      </div>
    )
  }
}

export default PrivacyPolicy




// WEBPACK FOOTER //
// ./src/components/privacy-policy/PrivacyPolicy.js